// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getCssUnitField from "@store/Framework/Common/Fields/Toolkit/cssUnit";
import ScrollWrapperComponent, {
    ScrollWrapperPresentationProps,
} from "@store/Library/Components/Toolkit/ScrollWrapper";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useMemo } from "react";
import { css } from "styled-components";
import * as cssLinter from "css";

const enum fields {
    height = "height",
    customCSS = "customCSS",
}

const heightField = getCssUnitField(fields.height);

interface ScrollWrapperProps extends WidgetProps {
    fields: {
        [fields.height]: string;
        [fields.customCSS]: string;
    };
}

export interface ScrollWrapperStyles {
    scrollWrapper?: ScrollWrapperPresentationProps;
}

export const scrollWrapperStyles: ScrollWrapperStyles = {};

const styles = scrollWrapperStyles;

const defaultCustomCss = `& {

}`;

const ScrollWrapper: FC<ScrollWrapperProps> = ({ fields: { height, customCSS }, id }) => {
    const scrollWrapperComponentStyles = useMemo(() => {
        return mergeProps<ScrollWrapperStyles["scrollWrapper"]>(styles.scrollWrapper, {
            extendedStyles: {
                wrapper: {
                    css: css`
                        ${breakpointValues(heightField.parse(height), "height")}
                        ${customCSS}
                    `,
                },
            },
        });
    }, [styles.scrollWrapper, height, customCSS]);

    return (
        <ScrollWrapperComponent {...scrollWrapperComponentStyles}>
            <Zone contentId={id} zoneName="Content" />
        </ScrollWrapperComponent>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: ScrollWrapper,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                ...heightField.definition,
                displayName: "Height",
                fieldType: "Contextual",
                defaultValue: "",
                tooltipPosition: "left",
                isRequired: true,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
